import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import Button from 'components/Button/Button';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import { useRoleAccess } from 'hooks/useRoleAccess';
import { UserRoles } from 'types';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import style from './EditBtn.module.scss';

const EditBtn: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);
	const hasAccess = useRoleAccess([
		UserRoles.SUPER_USER,
		UserRoles.CLIENT_MANAGER,
		UserRoles.GROUP_MANAGER,
		UserRoles.TECHNICAL,
	]);

	return (
		<Link to={`/clients/restaurants/edit?restaurantID=${restaurantForFullInfo?.id}`}>
			<Button
				className={style.btn}
				theme="primaryBlue"
				icon={
					<svg className={style.icon}>
						<use xlinkHref={`${breadcrumbs}#pencil`} />
					</svg>
				}
				disabled={!hasAccess}>
				<Text translationNameSpace="form" translationKey="editRestaurantButton" asFragment={true} />
			</Button>
		</Link>
	);
};

export default EditBtn;
